import React from "react";
import { Link } from "react-router-dom";

/**
 * Required acceptance of host terms before submitting a new listing.
 * Links to /terms#host (Host responsibilities).
 */
export default function HostTermsCheckbox({
  checked,
  onChange,
  testid = "host-terms-checkbox",
  disabled = false,
}) {
  return (
    <label className="flex items-start gap-3 text-sm" data-testid={testid}>
      <input
        type="checkbox"
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
        required
        className="w-4 h-4 mt-0.5 accent-[var(--zc-accent)] shrink-0"
        data-testid={`${testid}-input`}
        aria-describedby={`${testid}-hint`}
      />
      <span>
        <span className="block text-[var(--zc-text)]">
          I agree to the{" "}
          <Link
            to="/terms#host"
            className="text-[var(--zc-accent)] font-semibold underline-offset-2 hover:underline"
            data-testid={`${testid}-link`}
            onClick={(e) => e.stopPropagation()}
          >
            Host Terms &amp; Conditions
          </Link>
        </span>
        <span id={`${testid}-hint`} className="zc-meta block mt-0.5">
          Required before you can list a vehicle or parking spot.
        </span>
      </span>
    </label>
  );
}
